<template>
<div class="box-wrapper text-left">
	<template v-for="(item, name, index) in settings">
		<div v-bind:class="hasSetting(name)" v-on:click="showModal(name)" :key="index">
			<div class="box-inner">
				<div v-if="setDownload(name) && item.download !== null" class="download"><img :src="require(`@/assets/svg/ic_downloads.svg`)" :alt="'Image Setting ' + item.name"></div>
				<!-- <div v-if="item.banderole" class="banderole">{{ item.banderole }}</div> -->
				<div class="banderole">{{ setBanderole(name) }}</div>
				<div class="image">
					<img :src="require(`@/assets/img/${item.image}`)" :alt="'Image Setting ' + item.name">
				</div>
				<div class="title">{{ item.name }}</div>
			</div>
			<b-modal :id="name" hide-footer :title="item.name">
				<div class="row image-wrapper">
					<img :src="require(`@/assets/img/${item.image}`)" :alt="'Image Setting ' + item.name">
				</div>
				<p v-html="item.text">{{ item.text }}</p>
				<div v-if="setDownload(name) && item.download !== null"  class="container-banner">
					<p class="container-download">
						<a :href="item.download" class="button">Download Pack</a>
						<a href="https://www.caeora.com/" target="_blank">
							<img :src="require(`@/assets/img/caeora.png`)" :alt="'Image Setting ' + item.name">
						</a>
					</p>
				</div>
			</b-modal>
		</div>
	</template>
</div>
</template>

<script>
export default {
	name: 'SettingsItem',
	props: {
		user: Object,
		settings: Object,
		phase: Object,
	},
	methods: {
		showModal(id) {
			this.$bvModal.show(id)
		},

		setDownload(name) {
			if(this.setBanderole(name) === 'sub' && name === 'setting-base-fantasy' ) return true
			if(this.setBanderole(name) === 'sub' && name === 'setting-deadhaus-sonata' ) return true
			if(this.setBanderole(name) === 'included') return true

			return false
		},

		setBanderole(val) {
			if(
				this.user.token.groups.includes('/Platinum') ||
				this.user.token.groups.includes('/Platinum CL') ||
				this.user.token.groups.includes('/Lifetime') ||
				this.user.token.groups.includes('/Lifetime CL') ||
				this.user.token.groups.includes('/Lifetime 2017')
			) {
				return 'included';
			}

			if(
				this.user.token.groups.includes('/Gold PLUS') ||
				this.user.token.groups.includes('/Gold') ||
				this.user.token.groups.includes('/Silver') ||
				this.user.token.groups.includes('/Bronze') ||
				this.user.token.groups.includes('/Basic') ||
				this.user.token.groups.includes('/Preorder Sub') ||
				this.user.token.groups.includes('/Preorder Upgrade') ||
				this.user.token.groups.includes('/Preorder')
			)  {
				// included on sub
				if(
					typeof this.user.token.dungeonfog !== 'undefined' &&
					typeof this.user.token.dungeonfog.standalone_keys !== 'undefined' &&
					this.user.token.dungeonfog.standalone_keys > 0
				) {
					if(val == 'setting-base-fantasy' || val == 'setting-deadhaus-sonata') {
						return "included"
					}
				}

				if(
					this.user.token.groups.includes('/Preorder Sub') ||
					this.user.token.groups.includes('/Preorder Upgrade') ||
					this.user.token.groups.includes('/Preorder')
				) {
					if(val == 'setting-base-fantasy' || val == 'setting-deadhaus-sonata') {
						return "included"
					}
				}

				if(!this.user.token.groups.includes('/Basic')) {
					return 'sub';
				}
			}


		},

		hasSetting(val) {
			if(
				this.user.token.groups.includes('/Platinum') ||
				this.user.token.groups.includes('/Platinum CL') ||
				this.user.token.groups.includes('/Lifetime') ||
				this.user.token.groups.includes('/Lifetime CL') ||
				this.user.token.groups.includes('/Lifetime 2017')
			) {
				return 'box scale';
			}

			if(
				this.user.token.groups.includes('/Gold PLUS') ||
				this.user.token.groups.includes('/Gold') ||
				this.user.token.groups.includes('/Silver') ||
				this.user.token.groups.includes('/Bronze') ||
				this.user.token.groups.includes('/Basic') ||
				this.user.token.groups.includes('/Preorder Sub') ||
				this.user.token.groups.includes('/Preorder Upgrade') ||
				this.user.token.groups.includes('/Preorder')
			) {
				// included on sub
				if(
					typeof this.user.token.dungeonfog !== 'undefined' &&
					typeof this.user.token.dungeonfog.standalone_keys !== 'undefined' &&
					this.user.token.dungeonfog.standalone_keys > 0
				) {
					if(val == 'setting-base-fantasy' || val == 'setting-deadhaus-sonata') {
						return 'box scale';
					}
				}

				if(
					this.user.token.groups.includes('/Preorder Sub') ||
					this.user.token.groups.includes('/Preorder Upgrade') ||
					this.user.token.groups.includes('/Preorder')
				) {
					if(val == 'setting-base-fantasy' || val == 'setting-deadhaus-sonata') {
						return "box scale"
					} else {
						if(
							this.user.token.groups.includes('/Preorder Sub') ||
							this.user.token.groups.includes('/Preorder Upgrade')
						) {
							return "box scale"
						}
						return 'box scale locked';
					}
				}

				if(!this.user.token.groups.includes('/Basic')) {
					return 'box scale';
				}
			}

			return 'box scale locked';
		}
	},
}
</script>
